const BlogData = [
    {
      title: "How to make a Resume For Freshers!",
      description: "Creating a resume as a fresher can be challenging because you likely have limited work experience. However, you can still craft an impressive resume that highlights your skills, education, and any relevant experiences or achievements. Here’s a step-by-step guide to help you create an effective resume.",
      link: "https://medium.com/@amankohare/how-to-make-a-greate-resume-for-freshers-93913d82263a",
      image: "https://wallpaperaccess.com/full/4689415.png"
    },
    {
      title: "Connect Html form with Gmail using php.",
      description: "To connect an HTML form with Gmail, you can use a server-side programming language like PHP to handle the form submission and send the form data to your Gmail account. Here’s a step-by-step guide on how to achieve this.",
      link: "https://medium.com/@amankohare/connect-html-form-with-gmail-using-php-a7067baccd04",
      image: "https://ak5.picdn.net/shutterstock/videos/27007675/thumb/8.jpg"
    },
    {
      title: "How to deploy website on vercel?",
      description: "Vercel is a cloud platform that provides a serverless deployment platform for frontend developers. It allows developers to deploy their web applications, websites, and serverless functions with ease. Vercel supports various frontend frameworks, including React, Vue.js, Angular, and more.",
      link: "https://medium.com/@amankohare/how-to-deploy-website-on-vercel-da6c54a184d6",
      image: "https://i.ytimg.com/vi/IHRU2ox5Jzw/maxresdefault.jpg"
    },
    {
      title: "How To Become Successful Web developer",
      description: "Becoming a successful web developer involves a combination of technical skills, continuous learning, and a proactive approach to personal and professional growth. Here are some steps to help you become a successful web developer.",
      link: "https://medium.com/@amankohare/how-to-become-successful-web-developer-f44874874e23",
      image: "https://www.wallpapertip.com/wmimgs/160-1606283_web-developer-wallpaper.jpg"
    },
    {
      title: "Transfer data from an Android smartphone to an iPhone",
      description: "If you buy an iPhone, and before that you had an Android smartphone, then transferring data manually is very long and difficult. But there is a way to transfer everything in a few minutes: from contacts and messages to videos and apps.",
      link: "https://medium.com/@amankohare/transfer-data-from-an-android-smartphone-to-an-iphone-5bd755fd7e46",
      image: "https://static1.makeuseofimages.com/wp-content/uploads/2019/05/iphone-dark-mode-apps.jpg"
    },
    {
      title: "How to become mern stack developer",
      description: "To become a MERN (MongoDB, Express.js, React.js, Node.js) stack developer, you’ll need to follow a structured learning path and gain practical experience. Here’s a step-by-step guide to help you get started....",
      link: "https://medium.com/@amankohare/how-to-become-mern-stack-developer-b90ff2301cd3",
      image: "https://wallpaperbat.com/img/820041-mern-stack-wallpaper.jpg"
    },
  ];

  export default BlogData